import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from '../ai-answer-dialog/analytics-helpers';
import {
	type commonAttributesType,
	NonGenerativeAIAnswerResultShownProps,
} from '../ai-answer-dialog/types';

import { type KnowledgeCardsIntentType } from './types';

export const onKnowledgeCardShown = (
	props: commonAttributesType & { cardType: KnowledgeCardsIntentType },
): AnalyticsEventPayload => {
	const { source, cardType } = props;
	return {
		action: 'shown',
		actionSubject: 'aiAnswerDialog',
		actionSubjectId: 'knowledgeCard',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			cardType,
		},
	};
};

export const onKnowledgeCardLinkClick = (
	props: commonAttributesType,
	location: string,
): AnalyticsEventPayload => {
	const { source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerDialog',
		actionSubjectId: 'knowledgeCardLink',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			location,
		},
	};
};

// Fires the same event as onKnowledgeCardLinkClick but with less required attributes
// since some experiences don't have a plain text answer (e.g. Jira Issue Knowledge Card)
export const onNonGenerativeKnowledgeCardLinkClick = (
	props: NonGenerativeAIAnswerResultShownProps,
): AnalyticsEventPayload => {
	const { answerString, brand, query, queryHash, searchSessionId, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerDialog',
		actionSubjectId: 'knowledgeCardLink',
		source: source,
		eventType: 'track',
		attributes: {
			brand,
			queryHash,
			searchSessionId,
		},
		nonPrivacySafeAttributes: {
			answerString,
			query,
		},
	};
};
